export const mapCurrencyToSign = {
    GBP: '£',
    EUR: '€',
    USD: '$',
    JPY: '¥',
    ILS: '₪',
    AUD: 'A$'
};